import { useDispatch } from "react-redux";
import { useEffect } from "react";

import Navigation from "@/components/Navigation/Navigation";
import StatHeader from "../../components/Statistic/StatHeader/StatHeader";
import StatsMain from "@/components/Statistic/StatsMain/StatsMain";
import { setGlobalDate } from "@/store/schedule/scheduleSlice";

export default function Statistic() {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            const localDate = new Date();
            localDate.setHours(0, 0, 0, 0);
            const localDateString = localDate.toLocaleDateString("en-CA");
            const formattedDate = `${localDateString}T00:00:00.000+00:00`;
            dispatch(setGlobalDate(formattedDate));
        };
    }, [dispatch]);

    return (
        <div className='container patients_container'>
            <Navigation />
            <StatHeader />
            <StatsMain />
        </div>
    );
}
